import { Modal } from 'react-bootstrap';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  ModalApplyCtaButton,
  ModalCancelCtaButton,
} from '../../HostfullyAssist.styles';
import { AssistPropertiesSelectFormValues } from './AssistPropertiesSelectModal.schema';

const AssistPropertiesSelectModalFooter = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AssistPropertiesSelectFormValues>();
  const checkedProperties = useWatch({ control, name: 'properties' });
  const noneSelected = !Object.values(checkedProperties).some(Boolean);

  return (
    <Modal.Footer>
      <ModalCancelCtaButton data-testid="assist-cancel-properties" />
      <ModalApplyCtaButton
        data-testid="assist-apply-properties"
        disabled={noneSelected}
        disabledIfNotDirty={false}
      >
        {t('pageHostfullyAssist.details.propertiesSelectModal.apply')}
      </ModalApplyCtaButton>
    </Modal.Footer>
  );
};

export default AssistPropertiesSelectModalFooter;
